import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  padding: 16px;
  gap: 16px;
`;

export const Col = styled.div`
  ${({ md3 }) =>
    md3 &&
    css`
      @media (min-width: 768px) {
        -ms-flex: 1;
        flex: 1;
        max-width: 25%;
      }
    `}
  ${({ md9 }) =>
    md9 &&
    css`
      @media (min-width: 768px) {
        -ms-flex: 1;
        flex: 1;
        max-width: 75%;
      }
    `}
  ${({ md12 }) =>
    md12 &&
    css`
      @media (min-width: 768px) {
        -ms-flex: 1;
        flex: 1;
        max-width: 100%;
      }
    `}
`;
